import type { SVGProps } from "react";

export const DesktopArrowDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5303 6.46967C16.8232 6.76256 16.8232 7.23744 16.5303 7.53033L10.5303 13.5303C10.2374 13.8232 9.76256 13.8232 9.46967 13.5303L3.46967 7.53033C3.17678 7.23744 3.17678 6.76256 3.46967 6.46967C3.76256 6.17678 4.23744 6.17678 4.53033 6.46967L10 11.9393L15.4697 6.46967C15.7626 6.17678 16.2374 6.17678 16.5303 6.46967Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MobileArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M9 5.5L15.5 12L9 18.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DesktopArrowUp = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46967 13.5303C3.17678 13.2374 3.17678 12.7626 3.46967 12.4697L9.46967 6.46967C9.76256 6.17678 10.2374 6.17678 10.5303 6.46967L16.5303 12.4697C16.8232 12.7626 16.8232 13.2374 16.5303 13.5303C16.2374 13.8232 15.7626 13.8232 15.4697 13.5303L10 8.06066L4.53033 13.5303C4.23744 13.8232 3.76256 13.8232 3.46967 13.5303Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DesktopMenuClose = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
      <path
        d="M19.7071 7.70711C20.0976 7.31658 20.0976 6.68342 19.7071 6.29289C19.3166 5.90237 18.6834 5.90237 18.2929 6.29289L13 11.5858L7.70711 6.29289C7.31658 5.90237 6.68342 5.90237 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L11.5858 13L6.29289 18.2929C5.90237 18.6834 5.90237 19.3166 6.29289 19.7071C6.68342 20.0976 7.31658 20.0976 7.70711 19.7071L13 14.4142L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L14.4142 13L19.7071 7.70711Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MobileMenuSearch = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6875 17.8446C15.2711 19.0045 13.4602 19.7005 11.4866 19.7005C6.95021 19.7005 3.27272 16.023 3.27272 11.4866C3.27272 6.95022 6.95021 3.27273 11.4866 3.27273C16.023 3.27273 19.7005 6.95022 19.7005 11.4866C19.7005 13.4602 19.0045 15.2712 17.8445 16.6875L21.3058 20.1489C21.6253 20.4684 21.6253 20.9864 21.3058 21.306C20.9863 21.6255 20.4682 21.6255 20.1487 21.3059L16.6875 17.8446ZM18.0642 11.4866C18.0642 15.1193 15.1193 18.0642 11.4866 18.0642C7.85395 18.0642 4.90908 15.1193 4.90908 11.4866C4.90908 7.85396 7.85395 4.90909 11.4866 4.90909C15.1193 4.90909 18.0642 7.85396 18.0642 11.4866Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LineClose = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_11697_18554)">
        <path
          d="M18 6L6 18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6L18 18"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11697_18554">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LineCloseCircle = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_11734_25347)">
        <circle opacity="0.5" cx="12" cy="12" r="10" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1429 9.28033C16.4358 8.98744 16.4358 8.51256 16.1429 8.21967C15.85 7.92678 15.3752 7.92678 15.0823 8.21967L12.1813 11.1206L9.28033 8.21967C8.98744 7.92678 8.51256 7.92678 8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033L11.1206 12.1813L8.21967 15.0823C7.92678 15.3752 7.92678 15.85 8.21967 16.1429C8.51256 16.4358 8.98744 16.4358 9.28033 16.1429L12.1813 13.242L15.0823 16.1429C15.3752 16.4358 15.85 16.4358 16.1429 16.1429C16.4358 15.85 16.4358 15.3752 16.1429 15.0823L13.242 12.1813L16.1429 9.28033Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_11734_25347">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CircleDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <circle cx="9" cy="9" r="8" stroke="#B2B9BE" strokeWidth="1.5" />
  </svg>
);

export const CircleChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <circle cx="9" cy="10" r="8" stroke="#B2B9BE" strokeWidth="1.5" />
    <circle cx="9" cy="10" r="4" fill="#5194C1" />
  </svg>
);

export const CircleDefaultLg = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <circle cx="9" cy="10" r="8" stroke="#B2B9BE" strokeWidth="1.5" />
  </svg>
);

export const CircleCheckedBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <circle cx="9" cy="10" r="8" stroke="#5194C1" strokeWidth="1.5" />
    <circle cx="9" cy="10" r="4" fill="#5194C1" />
  </svg>
);

export const CheckboxNormal = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7483 4H8.25081C5.63805 4 4 5.84995 4 8.46789V15.5321C4 18.1501 5.63027 20 8.25081 20H15.7475C18.3689 20 20 18.1501 20 15.5321V8.46789C20 5.84995 18.3689 4 15.7483 4Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ChevronRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="6" height="10" viewBox="0 0 6 10" fill="none" {...props}>
      <path
        d="M1 9L5 5L1 1"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MobileListingCalendar = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M11.4 3.7C11.4 3.3134 11.7134 3 12.1 3C12.4866 3 12.8 3.3134 12.8 3.7V4.4H14.2C15.7464 4.4 17 5.6536 17 7.2H3C3 5.6536 4.2536 4.4 5.8 4.4H7.2V3.7C7.2 3.3134 7.5134 3 7.9 3C8.2866 3 8.6 3.3134 8.6 3.7V4.4H11.4V3.7Z"
        fill="#B2B9BE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 8.6H17V14.2C17 15.7464 15.7464 17 14.2 17H5.8C4.2536 17 3 15.7464 3 14.2V8.6ZM4.96 12.8C4.65072 12.8 4.4 13.0507 4.4 13.36V13.64C4.4 13.9493 4.65072 14.2 4.96 14.2H6.64C6.94928 14.2 7.2 13.9493 7.2 13.64V13.36C7.2 13.0507 6.94928 12.8 6.64 12.8H4.96ZM8.6 13.36C8.6 13.0507 8.85072 12.8 9.16 12.8H10.84C11.1493 12.8 11.4 13.0507 11.4 13.36V13.64C11.4 13.9493 11.1493 14.2 10.84 14.2H9.16C8.85072 14.2 8.6 13.9493 8.6 13.64V13.36ZM4.96 10C4.65072 10 4.4 10.2507 4.4 10.56V10.84C4.4 11.1493 4.65072 11.4 4.96 11.4H6.64C6.94928 11.4 7.2 11.1493 7.2 10.84V10.56C7.2 10.2507 6.94928 10 6.64 10H4.96ZM8.6 10.56C8.6 10.2507 8.85072 10 9.16 10H10.84C11.1493 10 11.4 10.2507 11.4 10.56V10.84C11.4 11.1493 11.1493 11.4 10.84 11.4H9.16C8.85072 11.4 8.6 11.1493 8.6 10.84V10.56ZM13.36 10C13.0507 10 12.8 10.2507 12.8 10.56V10.84C12.8 11.1493 13.0507 11.4 13.36 11.4H15.04C15.3493 11.4 15.6 11.1493 15.6 10.84V10.56C15.6 10.2507 15.3493 10 15.04 10H13.36Z"
        fill="#B2B9BE"
      />
    </svg>
  );
};

export const CheckboxFilled = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7483 4H8.25081C5.63805 4 4 5.84995 4 8.46789V15.5321C4 18.1501 5.63027 20 8.25081 20H15.7475C18.3689 20 20 18.1501 20 15.5321V8.46789C20 5.84995 18.3689 4 15.7483 4Z"
        stroke="currentColor"
        strokeWidth={props.strokeWidth ?? 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 12.5L10.6674 15L16 10"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DesktopPopupDone = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M4 10.5L8.5 15L16 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DesktopArrowLeft = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5303 16.5303C13.2374 16.8232 12.7626 16.8232 12.4697 16.5303L6.46967 10.5303C6.32902 10.3897 6.25 10.1989 6.25 10C6.25 9.80109 6.32902 9.61032 6.46967 9.46967L12.4697 3.46967C12.7626 3.17678 13.2374 3.17678 13.5303 3.46967C13.8232 3.76256 13.8232 4.23744 13.5303 4.53033L8.06066 10L13.5303 15.4697C13.8232 15.7626 13.8232 16.2374 13.5303 16.5303Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DesktopArrowRight = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.46967 3.46967C6.76256 3.17678 7.23744 3.17678 7.53033 3.46967L13.5303 9.46967C13.671 9.61032 13.75 9.80109 13.75 10C13.75 10.1989 13.671 10.3897 13.5303 10.5303L7.53033 16.5303C7.23744 16.8232 6.76256 16.8232 6.46967 16.5303C6.17678 16.2374 6.17678 15.7626 6.46967 15.4697L11.9393 10L6.46967 4.53033C6.17678 4.23744 6.17678 3.76256 6.46967 3.46967Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DefaultDoctorProfileIcon = () => (
  <svg
    width="110"
    height="110"
    viewBox="0 0 110 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="110" height="110" rx="55" fill="#F1F1F1" />
    <mask
      id="mask0_6550_43895"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="110"
      height="110"
    >
      <rect width="110" height="110" rx="55" fill="#B2B9BE" />
    </mask>
    <g mask="url(#mask0_6550_43895)">
      <g opacity="0.24" filter="url(#filter0_f_6550_43895)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55 19.25C43.6091 19.25 34.375 28.4841 34.375 39.875C34.375 48.2086 39.3175 55.3878 46.431 58.6412C27.7617 62.5855 13.75 79.1564 13.75 99C13.75 121.782 32.2183 140.25 55 140.25C77.7817 140.25 96.25 121.782 96.25 99C96.25 79.1564 82.2383 62.5855 63.569 58.6412C70.6825 55.3878 75.625 48.2086 75.625 39.875C75.625 28.4841 66.3909 19.25 55 19.25Z"
          fill="#5194C1"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_6550_43895"
        x="11.75"
        y="17.25"
        width="86.5"
        height="125"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_6550_43895"
        />
      </filter>
    </defs>
  </svg>
);

export const LineCloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#clip0_11562_37051)">
        <path
          d="M14 6L6 14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6L14 14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11562_37051">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ArrowCircleLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="-0.5"
      y="0.5"
      width="27"
      height="27"
      rx="13.5"
      transform="matrix(-1 0 0 1 27 0)"
      stroke={props.stroke}
    />
    <path
      d="M16 9L11 14L16 19"
      stroke={props.stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowCircleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="27"
      height="27"
      rx="13.5"
      stroke={props.stroke}
    />
    <path
      d="M12 9L17 14L12 19"
      stroke={props.stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const XIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_17473_95392)">
      <path
        d="M16.75 7.25L7.25 16.75"
        stroke="#B2B9BE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25 7.25L16.75 16.75"
        stroke="#B2B9BE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_17473_95392">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ArrowRight = ({
  variant = "active",
  ...props
}: SVGProps<SVGSVGElement> & { variant?: "inactive" | "active" }) => {
  const color = variant === "active" ? "#5194C1" : "#B2B9BE";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.27958 15.7225C6.90681 15.3526 6.90681 14.7527 7.27958 14.3827L11.6955 10L7.27958 5.61726C6.90681 5.24729 6.90681 4.64745 7.27958 4.27748C7.65235 3.90751 8.25674 3.90751 8.62951 4.27748L13.7204 9.33011C13.8994 9.50778 14 9.74874 14 10C14 10.2513 13.8994 10.4922 13.7204 10.6699L8.62951 15.7225C8.25674 16.0925 7.65235 16.0925 7.27958 15.7225Z"
        fill={color}
      />
    </svg>
  );
};

export const SearchTextIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9057 18.3198C15.551 19.3729 13.8487 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8487 19.3729 15.5509 18.3199 16.9056L21.7071 20.2929C22.0977 20.6834 22.0977 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.9057 18.3198ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z"
      fill="#74A9CD"
    />
  </svg>
);

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="9" cy="9" r="8.25" stroke="#5194C1" strokeWidth="1.5" />
    <path
      d="M9 13V7M9 6V5"
      stroke="#5194C1"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const CancelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_18663_2747)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46967 8.46967C8.76256 8.17678 9.23744 8.17678 9.53033 8.46967L12 10.9393L14.4697 8.46967C14.7626 8.17678 15.2374 8.17678 15.5303 8.46967C15.8232 8.76256 15.8232 9.23744 15.5303 9.53033L13.0607 12L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L12 13.0607L9.53033 15.5303C9.23744 15.8232 8.76256 15.8232 8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697L10.9393 12L8.46967 9.53033C8.17678 9.23744 8.17678 8.76256 8.46967 8.46967Z"
        fill="#5194C1"
      />
      <circle cx="12" cy="12" r="11.25" stroke="#5194C1" strokeWidth="1.5" />
    </g>
    <defs>
      <clipPath id="clip0_18663_2747">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ReviewIcon = ({
  variant = "inactive",
  fill,
  ...props
}: SVGProps<SVGSVGElement> & { variant?: "inactive" | "active" }) => {
  return variant === "inactive" ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 17.0029L6.3291 16.9316C5.95686 16.8921 5.58513 16.8478 5.21387 16.7998H5.21484C3.52424 16.5792 2.3125 15.1023 2.3125 13.3975V6.91504C2.3125 5.26399 3.45007 3.82505 5.05762 3.53711L5.21484 3.5127C7.34392 3.23567 9.51458 3.09375 11.7188 3.09375C13.9225 3.09375 16.0933 3.2357 18.2227 3.51172V3.5127C19.9046 3.73147 21.1162 4.9287 21.1162 6.65137C21.1162 8.83888 21.2457 13.0841 21.1201 15.0752C20.872 16.3247 19.6557 16.9268 18.3193 16.9268H12.6895L12.4697 17.1465C11.9963 17.6199 10.8509 18.6038 9.69824 19.5879C8.85881 20.3046 8.00764 21.0282 7.47168 21.5078L7.05273 21.8965C7.04842 21.9007 7.04302 21.9041 7.03711 21.9053C7.03122 21.9064 7.02508 21.9056 7.01953 21.9033C7.01382 21.901 7.00832 21.8967 7.00488 21.8916L7 21.874V17.0029Z"
        stroke="#B2B9BE"
        strokeWidth="1.5"
      />
      <path
        d="M16.4072 8.5625C17.8066 8.56206 19.2059 8.61909 20.6006 8.73438V8.73535C21.7949 8.83546 22.6884 9.85156 22.6885 11.0498V15.5146C22.6884 16.6399 21.9013 17.6047 20.8174 17.8008L20.5967 17.8291L20.2549 17.8564L19.5635 17.9111V21.0938C19.5633 21.0996 19.5618 21.1054 19.5586 21.1104C19.5552 21.1155 19.5496 21.1197 19.5439 21.1221C19.5384 21.1243 19.5323 21.1252 19.5264 21.124L19.5107 21.1152L16.6123 18.2188L16.3945 18.001L16.0869 17.999L15.1123 17.9834C14.4642 17.9672 13.8192 17.9397 13.1777 17.8994L12.2188 17.8301V17.8291L11.998 17.8008C10.9133 17.6042 10.126 16.6395 10.126 15.5146C10.126 14.8865 10.0715 14.0569 10.0498 13.3105C10.027 12.5246 10.0353 11.7454 10.1445 11.0488C10.2545 10.3471 10.4564 9.79717 10.7676 9.41699C11.0214 9.10698 11.3843 8.86377 11.9551 8.76758L12.2129 8.73633C13.2497 8.65012 14.2963 8.59509 15.3506 8.57324L16.4072 8.5625Z"
        fill="#FAFAFA"
        stroke="#B2B9BE"
        strokeWidth="1.5"
      />
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 17.0029L6.3291 16.9316C5.95686 16.8921 5.58513 16.8478 5.21387 16.7998H5.21484C3.52424 16.5792 2.3125 15.1023 2.3125 13.3975V6.91504C2.3125 5.26399 3.45007 3.82505 5.05762 3.53711L5.21484 3.5127C7.34392 3.23567 9.51458 3.09375 11.7188 3.09375C13.9225 3.09375 16.0933 3.2357 18.2227 3.51172V3.5127C19.9046 3.73147 21.1162 4.9287 21.1162 6.65137C21.1162 8.83888 21.2457 13.0841 21.1201 15.0752C20.872 16.3247 19.6557 16.9268 18.3193 16.9268H12.6895L12.4697 17.1465C11.9963 17.6199 10.8509 18.6038 9.69824 19.5879C8.85881 20.3046 8.00764 21.0282 7.47168 21.5078L7.05273 21.8965C7.04842 21.9007 7.04302 21.9041 7.03711 21.9053C7.03122 21.9064 7.02508 21.9056 7.01953 21.9033C7.01382 21.901 7.00832 21.8967 7.00488 21.8916L7 21.874V17.0029Z"
        stroke="#5194C1"
        strokeWidth="1.5"
      />
      <path
        d="M16.4072 8.5625C17.8066 8.56206 19.2059 8.61909 20.6006 8.73438V8.73535C21.7949 8.83546 22.6884 9.85156 22.6885 11.0498V15.5146C22.6884 16.6399 21.9013 17.6047 20.8174 17.8008L20.5967 17.8291L20.2549 17.8564L19.5635 17.9111V21.0938C19.5633 21.0996 19.5618 21.1054 19.5586 21.1104C19.5552 21.1155 19.5496 21.1197 19.5439 21.1221C19.5384 21.1243 19.5323 21.1252 19.5264 21.124L19.5107 21.1152L16.6123 18.2188L16.3945 18.001L16.0869 17.999L15.1123 17.9834C14.4642 17.9672 13.8192 17.9397 13.1777 17.8994L12.2188 17.8301V17.8291L11.998 17.8008C10.9133 17.6042 10.126 16.6395 10.126 15.5146C10.126 14.8865 10.0715 14.0569 10.0498 13.3105C10.027 12.5246 10.0353 11.7454 10.1445 11.0488C10.2545 10.3471 10.4564 9.79717 10.7676 9.41699C11.0214 9.10698 11.3843 8.86377 11.9551 8.76758L12.2129 8.73633C13.2497 8.65012 14.2963 8.59509 15.3506 8.57324L16.4072 8.5625Z"
        fill="#E7F0F6"
        stroke="#5194C1"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const RewriteIcon = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.3203 13.2073L22.0012 11L20.3569 13.7471"
      stroke="#5194C1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.78906 13.9338L4.25665 15.9737L5.70509 13.1185"
      stroke="#5194C1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5 13C21.5 17.6944 17.6944 21.5 13 21.5C11.033 21.5 9.222 20.8318 7.78166 19.7101C7.52015 19.5064 7.16129 19.4668 6.87424 19.6326C6.43354 19.887 6.35736 20.4923 6.75459 20.8104C8.46588 22.1806 10.6372 23 13 23C18.5228 23 23 18.5228 23 13C23 12.4891 22.9617 11.9871 22.8878 11.4968C22.8118 10.9931 22.249 10.7559 21.8079 11.0106C21.521 11.1763 21.3758 11.5065 21.4208 11.8347C21.473 12.2156 21.5 12.6047 21.5 13ZM4.42219 16.0995C4.7383 15.917 4.87669 15.5367 4.78316 15.1838C4.59843 14.487 4.5 13.755 4.5 13C4.5 8.30558 8.30558 4.5 13 4.5C15.341 4.5 17.4609 5.44636 18.9982 6.97738C19.2566 7.23476 19.6549 7.30493 19.9708 7.12256C20.3771 6.88799 20.4774 6.34346 20.1493 6.00808C18.3339 4.15198 15.8015 3 13 3C7.47715 3 3 7.47715 3 13C3 13.9345 3.1282 14.8392 3.36796 15.6972C3.49421 16.149 4.01594 16.3341 4.42219 16.0995Z"
      fill="#5194C1"
    />
  </svg>
);

export const BigSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="128"
    height="128"
    viewBox="0 0 124 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M69.7451 81.6201C44.0787 100.506 8.47136 83.966 1.11105 54.4251C-7.73024 15.0963 38.1019 -16.1534 70.9561 9.10561C86.9851 21.1175 93.9222 43.8063 85.3732 62.036C84.6829 63.5344 83.9535 65.1269 83.1156 66.545C82.1858 68.1625 80.986 69.0044 82.9764 70.392C90.5344 77.9697 117.765 105.397 125.298 113C131.024 118.611 125.999 128.887 117.901 127.654C113.511 126.964 111.011 122.799 107.946 119.993C101.769 113.817 75.9864 87.7271 69.7451 81.6201ZM44.4656 16.9741C24.943 16.4867 11.1688 37.7048 19.2112 55.2864C26.4295 71.7962 48.1625 77.1111 61.984 65.4205C81.7098 49.329 70.1349 16.4147 44.4656 16.9741Z"
      fill="white"
      fillOpacity="0.8"
    />
  </svg>
);

export const CheckedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 32.8L12.6 23.4L15.4 20.6L22 27.2L38.8 10.4C35 6.6 29.8 4 24 4C13 4 4 13 4 24C4 35 13 44 24 44C35 44 44 35 44 24C44 20.2 43 16.8 41.2 13.8L22 32.8Z"
      fill="#51B987"
    />
  </svg>
);
